
export default {
  'profileSelector': {
    'activeProfile': 'Active'
  }
}
